import React from "react";
import { ChevronDown, ChevronUp, Receipt } from "lucide-react";

const PREPARED_ITEMS = [
  "Verwijderbijdrage",
  "Keuring",
  "Reistijd / voorrijkosten",
  "Huur / materieel",
  "Onderaanneming",
  "Opslag / korting / risicoreserve",
];

export default function CalculatieOtherCostsSection({ open, onToggle }) {
  return (
    <section className="border border-slate-200 bg-white">
      <button
        type="button"
        onClick={onToggle}
        className="flex w-full items-center justify-between gap-3 border-b border-slate-200 px-4 py-3 text-left"
      >
        <div>
          <h3 className="text-sm font-semibold text-slate-900">Overige posten</h3>
          <p className="mt-1 text-sm text-slate-600">Voorbereid voor volgende fase zonder de huidige API-contracten te breken.</p>
        </div>
        {open ? <ChevronUp size={18} className="text-slate-500" /> : <ChevronDown size={18} className="text-slate-500" />}
      </button>

      {open ? (
        <div className="space-y-4 px-4 py-4">
          <div className="flex items-start gap-3 rounded-sm border border-dashed border-slate-300 bg-slate-50 p-4 text-sm text-slate-600">
            <Receipt size={18} className="mt-0.5 shrink-0 text-slate-400" />
            <div>
              <p className="font-medium text-slate-800">Nog geen persistente overige posten in huidige calculatie-API</p>
              <p className="mt-1">De werkplek is hier alvast op voorbereid. In een vervolgfase kunnen deze posten via een centrale calculatieService en uitgebreider datamodel worden toegevoegd.</p>
            </div>
          </div>

          <div className="grid gap-2 md:grid-cols-2 xl:grid-cols-3">
            {PREPARED_ITEMS.map((item) => (
              <div key={item} className="rounded-sm border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700">
                {item}
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </section>
  );
}
